import {Component} from '@angular/core';
import {AuthService} from '@core/modules/auth';
import {Theme} from '@shared/modules/users/types/user';
import {IconsService} from '@core/modules/platform/services/icons.service';
import {TranslateService} from '@core/modules/translation';
import {SupportedLangs} from '@core/modules/translation/services/translate.service';

@Component({
	selector: 'green-root',
	template: ` <app-toaster /> <router-outlet /> `,
})
export class AppComponent {
	constructor(
		private readonly translate: TranslateService,
		private readonly iconsService: IconsService,
		private readonly auth: AuthService
	) {
		this.iconsService.registerIcons();
		this.applyTheme();
		this.applyUserLanguage();
	}

	private applyUserLanguage() {
		const userLang = this.auth.currentUser()?.lang?.toLowerCase();
		const savedLang = localStorage.getItem('lang') as SupportedLangs;

		if (userLang && ['fr', 'en'].includes(userLang)) {
			this.translate.use(userLang as SupportedLangs);
		} else if (savedLang) {
			this.translate.use(savedLang);
		}
	}

	private applyTheme() {
		if (this.auth.currentUser()?.theme === Theme.DARK) {
			document.body.classList.add('dark');
		}
	}
}
